import { Card, Col, Form, Row } from "antd";
import React  from "react";

function VendorCommunications({ data }) {
  return (
    <Row>
      <Col span={24}>
        <Card title="Vendor Communications">
          <Form
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 11 }}
            labelWrap={{ span: 8 }}
          >
            <Form.Item label="Owner specific notes">
              <p>{data?.portalActivated}</p>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
}

export default VendorCommunications;
